import React from 'react';
import { saveAs } from 'file-saver';
import Button from './components/bootstrap/Button';
import Icon from './components/icon/Icon';

const ImageModal = (props: any) => {
	console.log('Image path:', props.img);

	const downloadImage = () => {
		saveAs(props.img);
	};
	let modelStyle = {
		display: 'block',
		backgroundColor: 'rgba(0,0,0,0.8)',
	};
	return (
		<div>
			<div className='modal show fade' style={modelStyle}>
				<div className='modal-dialog modal-dialog-centered'>
					<div
						className='modal-content'
						style={{ backgroundColor: 'transparent', border: 'none' }}>
						<div className='modal-body align-self-center'>
							<center>
								<img
									crossOrigin='anonymous'
									src={props.img}
									alt={props.img}
									style={{ maxWidth: '50rem' }}
								/>
							</center>
						</div>
					</div>
				</div>
				<div className='model-action'>
					<Button type='button' className='download-img' onClick={downloadImage}>
						<Icon icon='Download' className='fs-1' />
					</Button>
					<Button type='button' className='model-close' onClick={props.hide}>
						<Icon icon='Close' className='fs-1' />
					</Button>
				</div>
			</div>
		</div>
	);
};

export default ImageModal;

// ----- With PDF
// import React from 'react';
// import { saveAs } from 'file-saver';
// // import { Document, Page } from 'react-pdf';
// import Button from './components/bootstrap/Button';
// import Icon from './components/icon/Icon';

// const ImageModal = (props: any) => {
// 	const { img, hide, isPdf } = props;

// 	const downloadFile = () => {
// 		saveAs(img);
// 	};

// 	return (
// 		<div>
// 			<div
// 				className='modal show fade'
// 				style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.8)' }}>
// 				<div className='modal-dialog modal-dialog-centered'>
// 					<div
// 						className='modal-content'
// 						style={{ backgroundColor: 'transparent', border: 'none' }}>
// 						<div className='modal-body align-self-center'>
// 							<center>
// 								{isPdf ? (
// 									//   <Document file={img}>
// 									//     <Page pageNumber={1} width={600} />
// 									//   </Document>
// 									<img src={img} />
// 								) : (
// 									<img
// 										crossOrigin='anonymous'
// 										src={img}
// 										alt={img}
// 										style={{ maxWidth: '50rem' }}
// 									/>
// 								)}
// 							</center>
// 						</div>
// 					</div>
// 				</div>
// 				<div className='model-action'>
// 					<Button type='button' className='download-img' onClick={downloadFile}>
// 						<Icon icon='Download' className='fs-1' />
// 					</Button>
// 					<Button type='button' className='model-close' onClick={hide}>
// 						<Icon icon='Close' className='fs-1' />
// 					</Button>
// 				</div>
// 			</div>
// 		</div>
// 	);
// };

// export default ImageModal;
